<div class="activate-container">
    <header>
        <a href="https://www.humi.ca" target="_blank" class="logo">
            <app-humi-logo labelOrientation="horizontal" />
        </a>
    </header>
    <router-outlet />
</div>
